<template>
  <div class="wrapper">
    <!-- <van-search
      v-model="value"
      shape="round"
      background="#FFF"
      placeholder="请搜索医生姓名、科室名"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon">
      </template>
    </van-search> -->
    <lastpage></lastpage>
    <ul class="yardList" v-if="showIf">
      <li class="title">
        <span>选择就诊院区</span>
        <span @click="go">我的预约</span>
      </li>
      <li @click="push(item)" v-for="item in yardList" :key="item.hspCode">
        <ul class="content">
          <li class="name">{{item.hspName}}</li>
          <li class="grade">
            <span v-for="it in item.slogan" :key="it">{{it}}</span>
          </li>
          <li class="jianjie">
            简介：{{ item.descrip }}
          </li>
        </ul>
      </li>
    </ul>
    <div class="reminder" v-if="showIf">
      <p>温馨提示</p>
      <p>1、放号时间为早上7点，可提前7天预约！</p>
      <p>2、请提前半小时到相应诊区报道，不允许超前报道！</p>
      <p>3、超过预约时段报道视为迟到，迟到者需要在最后一位就诊，迟到三次将拉入黑名单禁止预约！</p>
      <p>4、过诊患者将延后三位，过诊三次将延后到最后一位，当天返诊患者优先就诊！</p>
      <p>5、为创建文明有序的就诊环境，请大家遵守分诊规则，勿浪费医院公共资源！</p>
    </div>
    <!-- <div class="query_content" v-if="!showIf">
      嗨害嗨
    </div> -->
    <judgment></judgment>
  </div>
</template>

<script>
import { selectBHosptialinfo } from "@/request/api.js"
import Judgment from "@/components/Judgment/Judgment.vue";
import lastpage from "@/components/lastpage/lastpage.vue";
export default {
  components: {
    Judgment,
    lastpage
  },
  data() {
    return {
      // value: "",
      showIf: true,
      yardList: []
    }
  },
  created() {
    this.gethospital();
  },
  methods: {
    // handleQuery(){
    //   console.log("搜索");
    //   if(this.value){
    //     this.showIf = false
    //   }else{
    //     this.showIf = true
    //   }
    // },
    async gethospital(){
      let res = await selectBHosptialinfo();
      this.yardList = res.data.obj;
      this.yardList.forEach(el => {
        el.slogan = el.slogan.split('，')
      });
    },
    push(data){
      sessionStorage.setItem("hspCode",data.hspCode);
      sessionStorage.setItem("hspName",data.hspName);
      this.$router.push("/DepartmentSelection");
    },
    go(){
      this.$router.push("/mySubscribe")
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F8F8F8;
  /deep/ .van-search__content{
    background-color: #E4E4E4;
  }
  .ss_icon{
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  .yardList{
    flex: 1;
    // margin-top: 10px;
    background-color: #FFF;
    display: flex;
    flex-flow: column nowrap;
    >li{
      padding: 20px;
      border: 1px solid #eee;
      display: flex;
      flex-flow: row nowrap;
      .content {
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        letter-spacing: 1px;
        .name {
          font-size: 17px;
          font-weight: bold;
        }
        .grade {
          margin: 14px 0px 16px;
          font-size: 14px;
          > span {
            color: #2a9dce;
            margin-right: 4px;
            padding: 3px 7px;
            border: 1px solid #2a9dce;
            border-radius: 3px;
          }
        }
        .jianjie{
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          font-size: 14px;
          color: #BDBDBD;
          overflow: hidden;
          -webkit-line-clamp: 2;
        }
        .details {
          > p {
            font-size: 16px;
            margin-bottom: 10px;
            font-weight: 600;
          }
          > span {
            line-height: 25px;
            font-size: 14px;
            color: #707070;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
    .title{
      font-weight: bold;
      font-size: 18px;
      padding: 10px 20px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      >span:nth-child(2){
        font-size: 16px;
        color: #42c6ff;
      }
    }
  }
  .reminder{
    margin-top: 5px;
    padding: 20px;
    background-color: #F4F6F5;
    letter-spacing: 1px;
    >p{
      margin-bottom: 10px;
      color: #BDBDBD;
    }
    >p:nth-child(1){
      font-size: 14px;
      font-weight: bold;
      color: #EFBE48;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/hospitalRegister.vue